import React, {useState} from 'react';
import {Button, Stack} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {finalize} from 'rxjs';
import {useSnackbar} from 'notistack';

import {clientsServicesService} from '@store/clients/services';

import {Add, Download, GroupAction} from '@icons/index';
import ClientsServicesTable from '@screens/admin/clients/services/ClientsServices.table';
import CreateServiceDrawer from '@screens/admin/clients/details/contractedServices/manageService/CreateService.drawer';
import {PriceChange} from '@mui/icons-material';
import UpdateServicesPricesModal from '@screens/admin/clients/services/UpdateServicesPrices.modal';
import UpdateServicesModal from '@screens/admin/clients/services/UpdateServices.modal';

const ClientsServicesTab = () => {
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();

  const [CSVLoading, setCSVLoading] = useState(false);
  const [showAddService, setShowAddService] = useState(false);
  const [showUpdatePrices, setShowUpdatePrices] = useState(false);
  const [showUpdates, setShowUpdates] = useState(false);

  const handleExportCSV = () => {
    setCSVLoading(true);
    clientsServicesService.getClientsServicesCSV()
      .pipe(finalize(() => setCSVLoading(false)))
      .subscribe({
        error: (err) => enqueueSnackbar(err.text, err.options),
      });
  };

  return (
    <Stack flex={1} width="100%" spacing={2} mt="-35px">
      <Stack alignSelf="flex-end" direction="row" alignItems="center" spacing={2}>
        <Button variant="outlined" color="primary" onClick={() => setShowUpdates(true)} startIcon={<GroupAction/>}>
          {t('clients.addButtons.updates')}
        </Button>
        <Button variant="outlined" color="primary" onClick={() => setShowUpdatePrices(true)} startIcon={<PriceChange/>}>
          {t('clients.addButtons.updatePrices')}
        </Button>
        <Button
          variant="outlined" color="primary"
          disabled={CSVLoading}
          onClick={handleExportCSV}
          startIcon={<Download/>}>
          {t('global.exportCSV')}
        </Button>
        <Button
          variant="contained" color="primary"
          onClick={() => setShowAddService(true)}
          startIcon={<Add/>}>
          {t('clients.addButtons.service')}
        </Button>
      </Stack>
      <Stack flex={1}>
        <ClientsServicesTable/>
      </Stack>
      {showAddService && (<CreateServiceDrawer handleClose={() => setShowAddService(false)}/>)}
      {showUpdatePrices && (<UpdateServicesPricesModal handleClose={() => setShowUpdatePrices(false)}/>)}
      {showUpdates && (<UpdateServicesModal handleClose={() => setShowUpdates(false)}/>)}
    </Stack>
  );
};

export default ClientsServicesTab;
